import script from "./BaseInput.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseInput.vue?vue&type=script&setup=true&lang=js"

import "./BaseInput.vue?vue&type=style&index=0&id=42599bd2&lang=scss"

const __exports__ = script;

export default __exports__